import { useEffect, useState } from 'react';

/**
 * True when the visitor has asked for reduced motion. Drives every cinematic
 * layer (the 3D dust, GSAP scroll scenes, magnetic buttons) to fall back to a
 * still, instantly-readable page — motion is an enhancement, never a gate.
 */
export function useReducedMotion(): boolean {
  const [reduced, setReduced] = useState<boolean>(
    () =>
      typeof window !== 'undefined' &&
      !!window.matchMedia?.('(prefers-reduced-motion: reduce)').matches,
  );

  useEffect(() => {
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    const onChange = (): void => setReduced(mq.matches);
    onChange();
    mq.addEventListener?.('change', onChange);
    return () => mq.removeEventListener?.('change', onChange);
  }, []);

  return reduced;
}
